// Carries the server's machine-readable code alongside its human-readable
// message, so a screen can branch on `code` (the private-video case in spec §7
// needs its own treatment) while still having a string it can render verbatim.
export class ApiRequestError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = 'ApiRequestError';
    this.code = code;
    this.status = status;
  }
}
